import { render, staticRenderFns } from "./BusServermanageServiceModal.vue?vue&type=template&id=0124f138&"
import script from "./BusServermanageServiceModal.vue?vue&type=script&lang=js&"
export * from "./BusServermanageServiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports